// colorWheel.ts
// 200 visually distinct color pairs for cycling through items in a set
// Returns [backgroundColor, foregroundColor] with good contrast

const generateDistinctColorPairs = (count: number): [string, string][] => {
  const colorPairs: [string, string][] = [];

  // We'll use the golden ratio to get a good distribution of hues
  const goldenRatio = 0.618033988749895;

  for (let i = 0; i < count; i++) {
    // Use golden ratio to get well-distributed hues
    const hue = (i * goldenRatio * 360) % 360;

    // Vary saturation between 60% and 90%
    const saturation = 60 + (i % 3) * 15;

    // Vary lightness between 45% and 65%
    const lightness = 45 + (i % 2) * 20;

    const backgroundColor = `hsl(${Math.round(hue)}, ${saturation}%, ${lightness}%)`;

    // Determine foreground color based on background lightness
    let foregroundColor: string;
    if (lightness < 50) {
      // Dark background - use white text
      foregroundColor = 'white';
    } else if (lightness < 55) {
      // Medium-dark background - use light gray text
      foregroundColor = '#f5f5f5';
    } else {
      // Light background - use black text
      foregroundColor = 'black';
    }

    colorPairs.push([backgroundColor, foregroundColor]);
  }

  return colorPairs;
};

const colorWheel: [string, string][] = generateDistinctColorPairs(200);

export default colorWheel;
